module.exports = __webpack_public_path__ + "media/public/fonts/QanelasBold/QanelasBold-c9f231a0094c733fd56dac9ceddf0814.ttf";